<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24 7A17 17 0 117 24 17 17 0 0124 7m0-3a20 20 0 1020 20A20 20 0 0024 4z"/><path d="M22.58 31a2 2 0 01-2.78 0l-7.32-6.77a1.5 1.5 0 012-2.2l6.61 6.11L33.43 15.7a1.5 1.5 0 112.14 2.1z"/></svg>